'use client'

import { Avatar, Icon, IconComponent } from '@graftcode/design-system'

import styles from '../../MobileMenu.module.scss'

interface MobileMenuFooterProps {
  /** Workspace name */
  workspaceName: string
  /** Workspace initials for avatar */
  workspaceInitials: string
  /** Workspace label (like on desktop WorkspaceSelect) */
  workspaceLabel?: string
  /** Handler for workspace selector click */
  onWorkspaceSelectorClick?: () => void
}

export function MobileMenuFooter({
  workspaceName,
  workspaceInitials,
  workspaceLabel,
  onWorkspaceSelectorClick,
}: MobileMenuFooterProps) {
  return (
    <div className={styles.footer}>
      <button className={styles.workspaceSelector} onClick={onWorkspaceSelectorClick}>
        <Avatar size={32} fallback={workspaceInitials} />
        <div className={styles.workspaceSelectorText}>
          <span className={styles.workspaceSelectorName}>{workspaceName}</span>
          {workspaceLabel && <span className={styles.workspaceSelectorLabel}>{workspaceLabel}</span>}
        </div>
        <IconComponent icon={Icon.ChevronRightRegular} size={20} />
      </button>
    </div>
  )
}
